export default __webpack_public_path__ + "static/media/Man.07668d28.svg";